/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CompetenceLookup } from './competenceLookup';
import { LiteracyLookup } from './literacyLookup';
import { SkillLookup } from './skillLookup';

export interface ActivityLookup { 
    readonly id: string;
    /**
     * UUID of the activity for historical reasons.
     */
    readonly uuid: string;
    /**
     * Zadejte název aktivity.
     */
    title: string;
    readonly isFavorite: boolean;
    skills: Array<SkillLookup>;
    competencies: Array<CompetenceLookup>;
    literacies: Array<LiteracyLookup>;
    /**
     * Activity is readonly only if activity_template is present
     */
    readonly isReadonly: boolean;
}